var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9899_43478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5477 8.18038L25.8204 0.453162C25.217 -0.150403 24.2385 -0.150403 23.6349 0.453162C23.0313 1.05673 23.0313 2.03516 23.6349 2.63872L28.7239 7.72782H1.54596C0.69244 7.72782 0.000488281 8.41977 0.000488281 9.27329C0.000488281 10.1268 0.69244 10.8188 1.54596 10.8188H28.7239L23.635 15.9078C23.0314 16.5114 23.0314 17.4899 23.635 18.0934C23.7783 18.2371 23.9486 18.351 24.1361 18.4287C24.3237 18.5064 24.5247 18.5462 24.7277 18.546C24.9307 18.5463 25.1317 18.5064 25.3192 18.4287C25.5068 18.351 25.6771 18.237 25.8204 18.0933L33.5477 10.366C34.1512 9.76244 34.1512 8.78394 33.5477 8.18038Z",
    fill: "#41B60B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.455 23.1819H5.27704L10.366 18.0928C10.9696 17.4893 10.9696 16.5108 10.366 15.9073C9.76257 15.3037 8.78401 15.3037 8.18044 15.9073L0.453162 23.6345C-0.150403 24.238 -0.150403 25.2165 0.453162 25.82L8.18038 33.5473C8.32372 33.6911 8.49407 33.805 8.68162 33.8827C8.86917 33.9604 9.07022 34.0003 9.27322 34C9.47621 34.0003 9.67725 33.9605 9.86478 33.8828C10.0523 33.8051 10.2226 33.6911 10.3659 33.5473C10.9695 32.9438 10.9695 31.9653 10.3659 31.3618L5.27697 26.2728H32.455C33.3085 26.2728 34.0005 25.5808 34.0005 24.7273C34.0005 23.8739 33.3085 23.1819 32.455 23.1819Z",
    fill: "#41B60B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9899_43478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransfer);
export default __webpack_public_path__ + "static/media/logo-transfer.bfbfbabd5fc269d80c7c8acdba79a9d2.svg";
export { ForwardRef as ReactComponent };